module.exports = __webpack_public_path__ + "static/media/e5.c97d5306.jpg";